import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Actions
import { getOrderVehicleData } from '../../../../actions/orders'

// Utils
import { hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../../../utils/auth'
import { translation } from '../../../../utils/helpers'

// Components
import Text from '../../../elements/text'

class RegistrationNumber extends Component {
  constructor (props) {
    super(props)

    this.state = {
      searchInputChanged: false,
      regNumberText: 0
    }

    this.searchBrandVin = this.searchBrandVin.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
  }

  searchBrandVin (e) {
    const { name, value } = e.target
    console.log('here')

    if (!value) return
    if (!hasSubscriptionPermission(this.props.auth, 10, 0) && !hasPartnerSubscriptionPermission(this.props.auth, 10)) return
    if (!this.state.searchInputChanged) return

    this.setState({ ExtraData: {} })
    this.props.getOrderVehicleData(value, name).then(res => {
      if (res.data.BrandOriginal !== null) {
        this.props.updateState({
          RegNumber: res.data.RegNr,
          ChassisNumber: res.data.ChassisNumber,
          BrandOriginal: res.data.BrandName,
          ExtraData: res.data
        })

        this.setState({
          searchInputChanged: false,
          regNumberText: res.data.DictionaryKey
        })

        if (![0, 1153].includes(res.data.DictionaryKey)) { // display if not empty or "Order with that reg. nr. already exists"
          // Toastr
          window.toastr.info(translation(res.data.DictionaryKey))
        }
      }
    }, (err) => {
      // Toastr
      window.toastr.error(translation(err.response.data.DictionaryKey), translation('216'))
    })
  }

  onInputChange (e) {
    if (e.target.value !== this.props.regNr) {
      this.setState({
        searchInputChanged: true
      })
    }

    this.props.onInputChange(e)
  }

  render () {
    let displayError = this.state.regNumberText === 1153 // "Order with that reg. nr. already exists"

    return (
      <Text
        redBorder={displayError}
        labelText={translation('78')}
        name='RegNumber'
        value={this.props.regNr}
        onBlur={this.searchBrandVin}
        onChange={this.onInputChange}
        autoComplete='off'
        errorText={displayError ? translation(this.state.regNumberText) : null}
         />
    )
  }
}

RegistrationNumber.propTypes = {
  regNr: PropTypes.string.isRequired,
  updateState: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getOrderVehicleData
})(RegistrationNumber)



// WEBPACK FOOTER //
// ./src/app/shared/modals/NewOrdersModal/RegistrationNumber/index.js